import styles from './eyeIcon.module.scss';

interface IEyeIconProps {
  width?: string;
  height?: string;
  bgColor?: string;
  eyeColor?: string;
  className?: string;
  slashColor?: string;
  strikeout?: boolean;
  onClick?: () => void;
}

function EyeIcon({
  width = '37',
  height = '37',
  bgColor = '#FFF',
  eyeColor = '#4E55A2',
  slashColor = '#F00',
  className,
  strikeout,
  onClick,
}: IEyeIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={[styles.icon, className].join(' ')}
    >
      <circle cx="18.5" cy="18.5" r="18.5" fill={bgColor} />
      <path
        d="M18.5333 12C14.2 12 10.4993 14.6953 9 18.5C10.4993 22.3047 14.2 25 18.5333 25C22.8667 25 26.5673 22.3047 28.0667 18.5C26.5673 14.6953 22.8667 12 18.5333 12ZM18.5333 23.2667C15.2487 23.2667 12.3193 21.4207 10.8893 18.5C12.3193 15.5793 15.2487 13.7333 18.5333 13.7333C21.818 13.7333 24.7473 15.5793 26.1773 18.5C24.7473 21.4207 21.818 23.2667 18.5333 23.2667ZM18.5333 14.6C16.384 14.6 14.6333 16.3507 14.6333 18.5C14.6333 20.6493 16.384 22.4 18.5333 22.4C20.6827 22.4 22.4333 20.6493 22.4333 18.5C22.4333 16.3507 20.6827 14.6 18.5333 14.6ZM18.5333 20.6667C17.3373 20.6667 16.3667 19.696 16.3667 18.5C16.3667 17.304 17.3373 16.3333 18.5333 16.3333C19.7293 16.3333 20.7 17.304 20.7 18.5C20.7 19.696 19.7293 20.6667 18.5333 20.6667Z"
        fill={eyeColor}
      />
      {strikeout ? (
        <line
          x1="10"
          y1="27" // Début du trait
          x2="27"
          y2="10" // Fin du trait
          stroke={slashColor}
          strokeWidth="2"
        />
      ) : null}
    </svg>
  );
}

export default EyeIcon;
